import { deleteEmptySearchParams } from '@s1/core/utilities';
import getVehicleJSON from './_vehicle-utils';

window.s1 = window.s1 || {};
window.s1.quicksearch = window.s1.quicksearch || {};

/**
 * Changes the styles for the model/body style toggle
 *
 * @returns {void}
 */
const changeStyles = async () => {
  const wrapperElement = document.getElementById('qsToggleWrapper');
  const qsBodyElement = document.getElementById('qsBody');
  if (document.getElementById('qsToggle').checked) {
    if (wrapperElement) {
      wrapperElement.classList.add('filter__toggle--bold');
    }
    if (qsBodyElement) {
      qsBodyElement.classList.add('filter__select--apply-borders');
    }
  } else if (wrapperElement) {
    wrapperElement.classList.remove('filter__toggle--bold');
  }
};

/**
 * Retrieves quick search preset values from BI
 *
 * @returns {Object}
 */
const getBIParams = () => {
  const userData = window?.s1?.markupModifier ?? window?.s1?.blockInjector;
  const renderApiParams = userData?.renderApi || {};

  const city = userData?.city || '';
  const state = userData?.countryRegionName || '';
  const locationString = city.length > 0 && state.length > 0 ? `${city}, ${state}` : '';

  // default values for qsdata object
  const qsDataDefaultsObj = {
    valid: false,
    body: '',
    cond: '',
    make: '',
    model: '',
    price: '',
    location: locationString,
    showBody: false,
  };

  let qsparams = {};

  if (renderApiParams.quickSearch !== undefined) {
    qsparams = renderApiParams.quickSearch;
  }

  // only run when blockInjector.quickSearch method is "javascript"
  if (qsparams.method === 'javascript') {
    qsDataDefaultsObj.valid = true;
    qsDataDefaultsObj.cond = qsparams.condition ? qsparams.condition : '';
    qsDataDefaultsObj.make = qsparams.make ? qsparams.make : '';
    qsDataDefaultsObj.model = qsparams.model ? qsparams.model : '';
    qsDataDefaultsObj.price = qsparams.price ? qsparams.price : '';
    qsDataDefaultsObj.title = qsparams.customTitle ? qsparams.customTitle : '';
    qsDataDefaultsObj.location = qsparams.location ? qsparams.location : '';

    // only select a body type when a model isn't set
    if (!qsDataDefaultsObj.model) {
      qsDataDefaultsObj.body = qsparams.bodyType ? qsparams.bodyType : '';
      qsDataDefaultsObj.showBody = true;
    }
  }

  return qsDataDefaultsObj;
};

/**
 * Sets the values of the hero heading and model and make quick search fields
 *
 * @param {Object} qsData default value for alpine quicksearch data object
 *
 * @returns {void}
 */
const preselectSearchFields = (qsData) => {
  // only change title if a custom title exists through bi
  let headingElem = document.getElementById('hero-heading');
  if (headingElem && qsData.title) {
    headingElem = qsData.title;
  }

  document.getElementById('qsMake').value = qsData.make;

  if (qsData.model) {
    document.getElementById('qsModel').disabled = false;
    document.getElementById('qsModel').value = qsData.model;
  }

  if (qsData.body) {
    document.getElementById('qsBody').value = qsData.body;
  }
};

/**
 * Sets the values of the qsData object for alpine
 *
 * @returns {void}
 */
const fillSearchFields = async () => {
  try {
    const json = await getVehicleJSON();

    const qsDataDefaultsObj = getBIParams();

    // assign vehicle data to alpinejs data object
    window.s1.alpine.data('qsData', () => ({
      makes: Object.keys(json),
      models: json,
      selectedCondition: qsDataDefaultsObj.cond,
      selectedMake: qsDataDefaultsObj.make,
      selectedModel: qsDataDefaultsObj.model,
      selectedBody: qsDataDefaultsObj.body,
      selectedPrice: qsDataDefaultsObj.price,
      showBody: qsDataDefaultsObj.showBody,
      make: '',
      model: '',
      location: qsDataDefaultsObj.location,
    }));

    window.s1.alpine.start();

    // only preselect search fields if quick search default data contains valid info
    if (qsDataDefaultsObj.valid) {
      preselectSearchFields(qsDataDefaultsObj);
    }
  } catch (err) {
    console.error(err);
  }
};

/**
 * Build query strings from selected filters and redirect to serp
 *
 * @param {string} selectedCondition selected vehicle condition
 * @param {string} selectedMake selected vehicle make
 * @param {string} selectedModel selected vehicle model
 * @param {string} selectedBody selected vehicle body style
 * @param {string} selectedPrice max vehicle price
 * @param {string} location location string in the format "city, state"
 *
 * @returns {void}
 */
const searchVehicles = ({
  selectedCondition,
  selectedMake,
  selectedModel,
  selectedBody,
  selectedPrice,
  location,
}) => {
  let loc = location;
  const userData = window?.s1?.markupModifier ?? window?.s1?.blockInjector;

  // only allow location submit in us
  if (userData?.country !== 'US') {
    loc = '';
  }

  let searchString = '';

  if (selectedMake) {
    searchString = selectedMake;
  } else {
    searchString = selectedCondition ?? 'new and used';
    searchString += ' cars';
  }

  searchString += ' near me';

  const params = new URLSearchParams({
    q: searchString,
    cond: selectedCondition,
    mk: selectedMake,
    mdl: selectedModel,
    bdy: selectedBody,
    'pr-mx': selectedPrice,
    loc,
  });

  deleteEmptySearchParams(params);

  window.location.href = `https://carsgenius.com/search?${params}`;
};

fillSearchFields();

/* set to s1 namespace */
window.s1.quicksearch = {
  searchVehicles,
  changeStyles,
};
